var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 174,
    fill: "none",
    viewBox: "0 0 260 174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M93.012 101.085H74.19l1.276 17.865 11.485-7.656c1.914-3.403 5.806-10.209 6.061-10.209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M78 85.944c6.644-17.911 18.657-23.352 23.833-23.833 7.944-1.565 30.189-3.756 55.611 0 25.422 3.755 30.333 39.12 29.611 56.333l-32.139 1.445h-50.194s-20.584 19.018-24.195 16.972C71.5 134.694 69.694 108.333 78 85.944z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M185.848 101.085c-.319-.319-18.822 0-19.141 0 .319 4.892.957 14.739.957 14.994 0 .32 18.184-2.233 18.503-2.233.255 0 .532-3.403.638-5.104-.213-2.446-.702-7.402-.957-7.657z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M138.601 104.734h16.417"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M157.876 100.811h-2.335v8.62h2.335v-8.62z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M72.894 118.964H55.986l-26.778 34.869"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M103.84 62.815l.159 35.061h52.161l-.083-34.423"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M105.384 65.782c-1.736 0-3.139-1.404-3.139-3.14v-2.194c0-1.736 1.403-3.14 3.139-3.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    d: "M105.384 65.782c-1.736 0-3.139-1.404-3.139-3.14v-2.194c0-1.736 1.403-3.14 3.139-3.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M154.686 65.782c1.735 0 3.139-1.404 3.139-3.14v-2.194c0-1.736-1.404-3.14-3.139-3.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    d: "M154.686 65.782c1.735 0 3.139-1.404 3.139-3.14v-2.194c0-1.736-1.404-3.14-3.139-3.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    d: "M130.076 90.322c-15.37-.67-24.482-11.925-24.482-26.639V53.545c0-14.714 10.962-26.639 24.482-26.639s24.482 11.925 24.482 26.639v10.132c0 14.713-7.829 26.676-24.482 26.645z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M111.254 49.678s.14 2.252-1.302 4.14c-1.442 1.89-3.675 1.04-4.562 10.528V49.678h5.864zM148.688 49.678s-.141 2.252 1.301 4.14c1.442 1.89 3.963 1.449 4.85 10.937V55.49l.102-5.812h-6.253zM155.145 37.963c0-10.591-8.926-19.186-19.945-19.186h-9.877c-11.013 0-19.946 8.588-19.946 19.18v9.928s49.749 1.142 49.762 0c.019-1.091.006-9.922.006-9.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M119.772 35.788l.242-.81h-1.582l-1.851 1.926h-1.123l.581-1.927h-1.697l-1.627 5.411h1.703l.581-1.933h1.429l.581 1.933h1.391l.242-.816-.625-2.049 1.755-1.735zM124.978 34.977h-4.179l-1.621 5.411h1.704l.574-1.933h.849l1.123 1.933h1.429l.242-.81-.759-1.123c.562-.083 1.104-.37 1.372-1.289l.23-.797c.031-.109.057-.211.063-.307.007-.083.007-.16 0-.23-.063-.51-.453-.855-1.027-.855zm-.963 2.164h-2.163l.21-.696h2.163l-.21.696zM128.615 36.445h2.775l.702-.542.281-.925h-5.021l-1.627 5.41h5.027l.434-1.474h-3.311l.166-.536h3.311l.415-1.39h-3.312l.16-.543zM135.072 34.977l-3.35 4.6-.243.811h1.742l.511-.81h2.316l.025.81h1.583l.242-.81-.587-4.6h-2.239zm-.421 3.204l1.123-1.66h.076l.115 1.66h-1.314zM144.815 34.977l-2.093 2.52h-.236l-.581-2.52h-1.895l-1.372 4.595-.248.816h1.716l.881-2.96h.121l.402 2.144h.944l1.691-2.144h.121l-.893 2.96h1.71l.242-.816 1.385-4.595h-1.895z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    d: "M160.868 49.678h-56.422v-2.546h56.371c.6 0 1.085.485 1.085 1.085v.433c0 .568-.46 1.028-1.034 1.028z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M113.921 57.634s2.361-.561 7.931 0M144.898 57.634s-4.37-.561-7.931 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M134.957 80.163s-4.077-2.628-9.309 0M130.076 69.853s-5.155 5.289 1.277 4.594"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M120.129 88.51s1.946 3.522 10.024 3.681c8.077.16 10.904-3.681 10.904-3.681M129.049 82.219s2.067.836 2.992 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M105.384 65.782c0-.153.421 24.782 24.622 24.782s24.099-21.611 24.099-21.611-7.676 17.285-14.879 16.423c-3.733-.446-6.049-1.442-14.982-.574-7.477.721-18.701-10.387-18.86-19.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M127.607 75.085l-3.65 1.94s8.646 1.154 12.104 0l-2.884-1.73-5.57-.21z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    d: "M99.329 118.141l.37-55.006"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M102.245 62.178c-1.181 0-20.418.638-28.393 38.984 0 0 17.495-.07 19.154-.063"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M86.932 111.307c4.466-8.294 18.465-26.696 18.465-26.696 2.15-3.783 3.011-10.464 3.011-10.464l-.21-7.829s-.102-2.628 1.92-2.105c2.023.523 1.997 4.843 1.997 4.843l3.924-11.204s.396-1.008 1.315-1.206c.918-.198 1.875 1.263 1.614 1.799-.268.536-2.871 11.077-2.871 11.077l5.64-12.194s.562-1.237 1.563-1.072c.906.147 1.059 1.238.836 1.66-.223.42-4.524 12.377-4.524 12.377l6.394-10.17s.963-1.161 2.131-.37c.248.166.421.76.172 1.627-.262.932-5.615 11.37-5.615 11.37l6.661-6.425s1.174-.594 1.589-.077c.766.964-.472 2.457-.472 2.457l-6.559 7.88s-1.844 3.209-4.786 8.116c0 0-14.375 52.185-34.154 52.83-17.82.58-10.802-36.426-10.802-36.426"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M86.932 111.307c4.466-8.294 18.465-26.696 18.465-26.696 2.15-3.783 3.011-10.464 3.011-10.464l-.21-7.829s-.102-2.628 1.92-2.105c2.023.523 1.997 4.843 1.997 4.843l3.924-11.204s.396-1.008 1.315-1.206c.918-.198 1.875 1.263 1.614 1.799-.268.536-2.871 11.077-2.871 11.077l5.64-12.194s.562-1.237 1.563-1.072c.906.147 1.059 1.238.836 1.66-.223.42-4.524 12.377-4.524 12.377l6.394-10.17s.963-1.161 2.131-.37c.248.166.421.76.172 1.627-.262.932-5.615 11.37-5.615 11.37l6.661-6.425s1.174-.594 1.589-.077c.766.964-.472 2.457-.472 2.457l-6.559 7.88s-1.844 3.209-4.786 8.116c0 0-14.375 52.185-34.154 52.83-17.82.58-10.802-36.426-10.802-36.426"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M104.797 120.239l50.827-.128M187.105 118.964h16.908l26.779 34.869"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D1D1B",
    strokeMiterlimit: 10,
    d: "M76.085 20.704v22.332M59.496 48.14v44.026M49.925 78.128V96.63M176.896 19.428v26.798M190.933 30.913v42.75M197.313 64.73v16.589M207.522 97.908v11.485"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    d: "M160.817 118.141l-.6-55.236"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M158.393 62.223c1.18 0 20.487-.064 27.959 38.901 0 0-17.495-.025-19.154-.012"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M173.214 111.307c-4.466-8.294-18.465-26.696-18.465-26.696-2.15-3.783-3.011-10.464-3.011-10.464l.21-7.829s.103-2.628-1.92-2.105c-2.023.523-1.997 4.843-1.997 4.843l-3.924-11.204s-.396-1.008-1.315-1.206c-.918-.198-1.875 1.263-1.614 1.799.262.536 2.871 11.077 2.871 11.077l-5.64-12.194s-.561-1.237-1.563-1.072c-.906.147-1.059 1.238-.836 1.66.223.42 4.524 12.377 4.524 12.377l-6.393-10.17s-.964-1.161-2.132-.37c-.248.166-.421.76-.172 1.627.262.932 5.615 11.37 5.615 11.37l-6.661-6.425s-1.174-.594-1.589-.077c-.766.964.472 2.457.472 2.457l6.559 7.88s1.844 3.209 4.786 8.116c0 0 14.375 52.185 34.154 52.83 17.821.58 10.802-36.426 10.802-36.426"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M173.214 111.307c-4.466-8.294-18.465-26.696-18.465-26.696-2.15-3.783-3.011-10.464-3.011-10.464l.21-7.829s.103-2.628-1.92-2.105c-2.023.523-1.997 4.843-1.997 4.843l-3.924-11.204s-.396-1.008-1.315-1.206c-.918-.198-1.875 1.263-1.614 1.799.262.536 2.871 11.077 2.871 11.077l-5.64-12.194s-.561-1.237-1.563-1.072c-.906.147-1.059 1.238-.836 1.66.223.42 4.524 12.377 4.524 12.377l-6.393-10.17s-.964-1.161-2.132-.37c-.248.166-.421.76-.172 1.627.262.932 5.615 11.37 5.615 11.37l-6.661-6.425s-1.174-.594-1.589-.077c-.766.964.472 2.457.472 2.457l6.559 7.88s1.844 3.209 4.786 8.116c0 0 14.375 52.185 34.154 52.83 17.821.58 10.802-36.426 10.802-36.426"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H260V173.333H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H202.222V135.374H0z",
    transform: "translate(28.889 18.777)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.80560ce393ccb432019ba7770211b1e5.svg";
export { ForwardRef as ReactComponent };